// base
export const TAB = 'TAB';

// 用户
export const USER_LOGIN = 'USER_LOGIN'; //登录


// WEBPACK FOOTER //
// ./src/store/types.js